/**
 * Open a signed-document URL in a new tab while preserving the click's
 * user-activation gesture. The blank tab is opened SYNCHRONOUSLY (before any
 * await) so the pop-up blocker keeps it (spec-10e openability); no `noopener`
 * token, so the handle is non-null and we can point it at the resolved URL.
 */
export async function openSignedDocument(getUrl: () => Promise<string>): Promise<void> {
  const tab = window.open('about:blank', '_blank') // no noopener → handle kept
  try {
    const url = await getUrl()
    if (tab) {
      tab.location.href = url
      tab.opener = null // reverse-tabnabbing protection
    } else {
      window.location.assign(url) // only when the pop-up was genuinely blocked
    }
  } catch (err) {
    tab?.close() // never leave an empty tab on fetch error
    throw err // re-throw so callers keep control of their own error UI
  }
}
